export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Program", id: "program" },
  { label: "Business Models", id: "models" },
  { label: "Tools You'll Learn", id: "tools" },
  { label: "Practical Training", id: "practical" },
  { label: "About Us", id: "about" },
  { label: "Contact", id: "contact" },
];

export const MODELS = [
  {
    n: "01",
    title: "D2C Brand Building",
    desc: "Learn how to create and sell your own branded products directly to customers.",
    items: [
      "Market and customer research",
      "Product selection and validation",
      "Product sourcing and supplier evaluation",
      "Brand name, positioning and packaging",
      "Pricing and unit economics",
      "Shopify website creation",
      "Meta Ads and Google Ads",
      "COD, prepaid orders, shipping, NDR and RTO",
      "Customer support and retention",
      "Profitability and business scaling",
    ],
  },
  {
    n: "02",
    title: "Dropshipping",
    desc: "Learn how to test and sell products without holding large quantities of inventory.",
    items: [
      "Dropshipping business structure",
      "Product and supplier research",
      "Product sampling and quality checks",
      "Supplier agreements and dispatch processes",
      "Website and product-page creation",
      "Creative and video-ad production",
      "Meta advertising",
      "Order confirmation and fulfilment",
      "Returns, refunds and RTO control",
      "Moving successful products towards branding and inventory",
    ],
  },
  {
    n: "03",
    title: "Print-on-Demand",
    desc: "Learn how to sell customised merchandise that is produced after receiving an order.",
    items: [
      "Selecting a profitable niche",
      "Creating original design concepts",
      "T-shirts, mugs, merchandise and personalised products",
      "Finding print-on-demand suppliers",
      "Product mockups and size charts",
      "Shopify and WooCommerce integration",
      "Pricing and contribution margins",
      "Organic content and Meta Ads",
      "Copyright and trademark basics",
      "Bundles, seasonal collections and product launches",
    ],
  },
  {
    n: "04",
    title: "Digital Marketing Agency",
    desc: "Learn how to provide marketing services to local businesses, professionals and online brands.",
    items: [
      "Selecting an agency niche",
      "Creating service packages",
      "Meta Ads services",
      "Google Ads services",
      "Social-media and lead-generation services",
      "Finding and approaching potential clients",
      "Conducting business audits",
      "Sales calls and client proposals",
      "Client onboarding and account access",
      "Campaign reporting and client retention",
      "Monthly retainers, expenses and agency profit",
    ],
  },
  {
    n: "05",
    title: "Amazon and Flipkart Selling",
    desc: "Learn how products are launched, marketed and operated on major online marketplaces.",
    items: [
      "Marketplace product research",
      "Seller-account requirements",
      "Product sourcing and documentation",
      "Product catalogue and listing creation",
      "Titles, keywords, descriptions and images",
      "Pricing and marketplace fees",
      "Inventory and order management",
      "Amazon and Flipkart advertising",
      "Returns and settlement reconciliation",
      "Seller ratings and account health",
      "Marketplace profitability analysis",
    ],
  },
];

export const TOOL_CATEGORIES = [
  { title: "Website & Store Tools", items: ["Shopify", "WordPress", "WooCommerce", "Wix", "Domain & hosting platforms", "Payment-gateway systems"] },
  { title: "Advertising Tools", items: ["Meta Ads Manager", "Meta Business Portfolio", "Facebook & Instagram Ads", "Google Ads", "Google Keyword Planner", "Marketplace ad dashboards"] },
  { title: "Analytics & Tracking", items: ["Google Analytics 4", "Google Tag Manager", "Meta Pixel", "Conversion API fundamentals", "Shopify Analytics", "Ad-performance dashboards"] },
  { title: "Marketplace Tools", items: ["Amazon Seller Central", "Flipkart Seller Hub", "Marketplace fee calculators", "Listing & keyword tools", "Inventory & settlement reports"] },
  { title: "Content & Design Tools", items: ["Canva", "CapCut", "Adobe Express", "AI scriptwriting tools", "AI image & creative tools", "File-sharing & review tools"] },
  { title: "Sales & Communication", items: ["WhatsApp Business", "Lead forms", "CRM fundamentals", "Email communication", "Client proposals", "Google Forms"] },
  { title: "Business & Operations", items: ["Google Sheets", "Google Drive", "Notion", "Trello", "Shipping aggregators", "Courier dashboards", "Zoho Books & Tally basics"] },
];

export const PRACTICAL_ITEMS = [
  "Market-research assignments",
  "Product and business-model evaluation",
  "Customer-persona creation",
  "Business cost and profit calculations",
  "Brand and offer creation",
  "Shopify website or landing-page project",
  "Product-page and marketplace-listing creation",
  "Advertising-copy and creative development",
  "Meta Ads campaign planning",
  "Google Ads campaign planning",
  "Amazon or Flipkart listing project",
  "Digital marketing agency service package",
  "Sales proposal and client-onboarding process",
  "Order and operations workflow",
  "Business analytics dashboard",
  "Final business execution project",
];

export const PROJECT_CHOICES = ["D2C Brand", "Dropshipping Store", "Print-on-Demand Business", "Digital Marketing Agency", "Amazon / Flipkart Marketplace Business"];

export const PROJECT_DELIVERABLES = [
  "Target-customer profile",
  "Market and competitor research",
  "Business offer",
  "Brand or agency positioning",
  "Required digital tools",
  "Cost and profitability plan",
  "Marketing strategy",
  "Sales or website funnel",
  "Operating process",
  "30-day launch plan",
];

export const PERSONAS = [
  { title: "Students", desc: "Who want practical business skills beyond theory." },
  { title: "Aspiring Entrepreneurs", desc: "Ready to evaluate and launch an online business." },
  { title: "Existing Business Owners", desc: "Who want to grow their business online." },
  { title: "Homemakers", desc: "Interested in home-based business opportunities." },
  { title: "Freelancers", desc: "Who want to offer professional marketing services." },
  { title: "Marketplace Sellers", desc: "Interested in selling through Amazon and Flipkart." },
  { title: "Content Creators", desc: "Who want to monetise their audience or skills." },
  { title: "Marketing & Sales Professionals", desc: "Who want to deepen their business understanding." },
  { title: "Curious Beginners", desc: "Anyone who wants to understand how modern online businesses operate." },
];

export const WHY_POINTS = [
  "Five online business models in one program",
  "Practical, classroom-based training",
  "Business-focused learning instead of tool-only training",
  "Real-world examples and case studies",
  "Dedicated execution guides for each business model",
  "Website, advertising, content and marketplace training",
  "Profitability and unit-economics calculations",
  "Assignments, assessment and final project",
  "Small batches for better interaction",
  "Guidance from business idea to execution plan",
];

export const PROGRAM_DETAILS = [
  ["Program Name", "45-Day Practical Online Business Program"],
  ["Training Mode", "Offline Classroom Training"],
  ["Location", "LaunchX Academy, Rampur, Uttar Pradesh"],
  ["Program Duration", "45 Days"],
  ["Program Fee", "₹14,999"],
  ["Batch Size", "Limited Seats"],
  ["Practical Project", "Included"],
  ["Assignments & Assessment", "Included"],
  ["LaunchX Academy Certificate", "Included"],
  ["Free Counselling Session", "Available before admission"],
];

export const FAQS = [
  { q: "Is this only an e-commerce course?", a: "No. E-commerce is an important part of the program, but students also explore dropshipping, print-on-demand, digital marketing agency services and Amazon–Flipkart selling." },
  { q: "Will I learn Shopify, Meta Ads and Google Ads?", a: "Yes. The program includes practical training in website creation, Meta advertising, Google advertising, tracking and analytics." },
  { q: "Do I need coding knowledge?", a: "No. Advanced coding knowledge is not required. Students learn to use modern no-code and beginner-friendly business tools." },
  { q: "Will I practically start a business?", a: "Every student will select one business model and create a practical final project. Launching an actual business may require separate capital, registrations, tools, inventory or advertising investment depending on the chosen model." },
  { q: "Is advertising expenditure included in the course fee?", a: "No. Any live advertising budget, paid software, domain, product samples, inventory or external platform charges required for an individual student project are separate unless specifically stated." },
  { q: "Is the program online or offline?", a: "The program is conducted through offline classroom training at LaunchX Academy in Rampur, Uttar Pradesh." },
  { q: "What is the program fee?", a: "The fee for the complete 45-day program is ₹14,999." },
  { q: "Will I receive a certificate?", a: "Yes. Students who complete the required attendance, assignments, practical project and final assessment will receive a LaunchX Academy certificate." },
];

export const PRICING_INCLUDES = [
  "Five online business models in one program",
  "45-day offline classroom training",
  "Practical assignments & assessment",
  "Website, advertising & marketplace training",
  "Business economics & profitability calculations",
  "Digital tools & execution guides",
  "Final business execution project",
  "LaunchX Academy certificate",
  "Small batch with classroom doubt support",
];

export const AGE_GROUPS = ["Under 18", "18–21", "22–25", "26–30", "31–40", "40+"];
export const STATUSES = ["Student", "Working Professional", "Business Owner", "Homemaker", "Freelancer", "Content Creator", "Other"];
export const INTERESTS = ["D2C Brand Building", "Dropshipping", "Print-on-Demand", "Digital Marketing Agency", "Amazon / Flipkart Selling", "Not Sure Yet — Need Counselling"];
